export function makeHomepageUrl(server) {
    const M = (j) => server + '/backoffice/proxy/core-basic-api/home' + j;
    return {
        homepage: {
            setProductUpdates: M('/dynamic-product'),
            uploadAdImg: M('/upload-img'),
            setAdImage: M('/dynamic-picture'),
        },
    };
}
